/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as WallRouteImport } from "./routes/wall";
import { Route as TermsRouteImport } from "./routes/terms";
import { Route as PrivacyRouteImport } from "./routes/privacy";
import { Route as MeRouteImport } from "./routes/me";
import { Route as LeaderboardsRouteImport } from "./routes/leaderboards";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as RacesIndexRouteImport } from "./routes/races.index";
import { Route as OracleIndexRouteImport } from "./routes/oracle.index";
import { Route as RacesSlugRouteImport } from "./routes/races.$slug";
import { Route as OracleRaceSlugRouteImport } from "./routes/oracle.$raceSlug";
import { Route as BoomIdRouteImport } from "./routes/boom.$id";
import { Route as AuthStravaRouteImport } from "./routes/auth.strava";
import { Route as UHandleIndexRouteImport } from "./routes/u.$handle.index";
import { Route as UHandleVsRivalRouteImport } from "./routes/u.$handle.vs.$rival";

const WallRoute = WallRouteImport.update({
  id: "/wall",
  path: "/wall",
  getParentRoute: () => rootRouteImport,
} as any);
const TermsRoute = TermsRouteImport.update({
  id: "/terms",
  path: "/terms",
  getParentRoute: () => rootRouteImport,
} as any);
const PrivacyRoute = PrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => rootRouteImport,
} as any);
const MeRoute = MeRouteImport.update({
  id: "/me",
  path: "/me",
  getParentRoute: () => rootRouteImport,
} as any);
const LeaderboardsRoute = LeaderboardsRouteImport.update({
  id: "/leaderboards",
  path: "/leaderboards",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const RacesIndexRoute = RacesIndexRouteImport.update({
  id: "/races/",
  path: "/races/",
  getParentRoute: () => rootRouteImport,
} as any);
const OracleIndexRoute = OracleIndexRouteImport.update({
  id: "/oracle/",
  path: "/oracle/",
  getParentRoute: () => rootRouteImport,
} as any);
const RacesSlugRoute = RacesSlugRouteImport.update({
  id: "/races/$slug",
  path: "/races/$slug",
  getParentRoute: () => rootRouteImport,
} as any);
const OracleRaceSlugRoute = OracleRaceSlugRouteImport.update({
  id: "/oracle/$raceSlug",
  path: "/oracle/$raceSlug",
  getParentRoute: () => rootRouteImport,
} as any);
const BoomIdRoute = BoomIdRouteImport.update({
  id: "/boom/$id",
  path: "/boom/$id",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthStravaRoute = AuthStravaRouteImport.update({
  id: "/auth/strava",
  path: "/auth/strava",
  getParentRoute: () => rootRouteImport,
} as any);
const UHandleIndexRoute = UHandleIndexRouteImport.update({
  id: "/u/$handle/",
  path: "/u/$handle/",
  getParentRoute: () => rootRouteImport,
} as any);
const UHandleVsRivalRoute = UHandleVsRivalRouteImport.update({
  id: "/u/$handle/vs/$rival",
  path: "/u/$handle/vs/$rival",
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/leaderboards": typeof LeaderboardsRoute;
  "/me": typeof MeRoute;
  "/privacy": typeof PrivacyRoute;
  "/terms": typeof TermsRoute;
  "/wall": typeof WallRoute;
  "/auth/strava": typeof AuthStravaRoute;
  "/boom/$id": typeof BoomIdRoute;
  "/oracle/$raceSlug": typeof OracleRaceSlugRoute;
  "/races/$slug": typeof RacesSlugRoute;
  "/oracle/": typeof OracleIndexRoute;
  "/races/": typeof RacesIndexRoute;
  "/u/$handle/": typeof UHandleIndexRoute;
  "/u/$handle/vs/$rival": typeof UHandleVsRivalRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/leaderboards": typeof LeaderboardsRoute;
  "/me": typeof MeRoute;
  "/privacy": typeof PrivacyRoute;
  "/terms": typeof TermsRoute;
  "/wall": typeof WallRoute;
  "/auth/strava": typeof AuthStravaRoute;
  "/boom/$id": typeof BoomIdRoute;
  "/oracle/$raceSlug": typeof OracleRaceSlugRoute;
  "/races/$slug": typeof RacesSlugRoute;
  "/oracle": typeof OracleIndexRoute;
  "/races": typeof RacesIndexRoute;
  "/u/$handle": typeof UHandleIndexRoute;
  "/u/$handle/vs/$rival": typeof UHandleVsRivalRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/leaderboards": typeof LeaderboardsRoute;
  "/me": typeof MeRoute;
  "/privacy": typeof PrivacyRoute;
  "/terms": typeof TermsRoute;
  "/wall": typeof WallRoute;
  "/auth/strava": typeof AuthStravaRoute;
  "/boom/$id": typeof BoomIdRoute;
  "/oracle/$raceSlug": typeof OracleRaceSlugRoute;
  "/races/$slug": typeof RacesSlugRoute;
  "/oracle/": typeof OracleIndexRoute;
  "/races/": typeof RacesIndexRoute;
  "/u/$handle/": typeof UHandleIndexRoute;
  "/u/$handle/vs/$rival": typeof UHandleVsRivalRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/leaderboards"
    | "/me"
    | "/privacy"
    | "/terms"
    | "/wall"
    | "/auth/strava"
    | "/boom/$id"
    | "/oracle/$raceSlug"
    | "/races/$slug"
    | "/oracle/"
    | "/races/"
    | "/u/$handle/"
    | "/u/$handle/vs/$rival";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/leaderboards"
    | "/me"
    | "/privacy"
    | "/terms"
    | "/wall"
    | "/auth/strava"
    | "/boom/$id"
    | "/oracle/$raceSlug"
    | "/races/$slug"
    | "/oracle"
    | "/races"
    | "/u/$handle"
    | "/u/$handle/vs/$rival";
  id:
    | "__root__"
    | "/"
    | "/leaderboards"
    | "/me"
    | "/privacy"
    | "/terms"
    | "/wall"
    | "/auth/strava"
    | "/boom/$id"
    | "/oracle/$raceSlug"
    | "/races/$slug"
    | "/oracle/"
    | "/races/"
    | "/u/$handle/"
    | "/u/$handle/vs/$rival";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  LeaderboardsRoute: typeof LeaderboardsRoute;
  MeRoute: typeof MeRoute;
  PrivacyRoute: typeof PrivacyRoute;
  TermsRoute: typeof TermsRoute;
  WallRoute: typeof WallRoute;
  AuthStravaRoute: typeof AuthStravaRoute;
  BoomIdRoute: typeof BoomIdRoute;
  OracleRaceSlugRoute: typeof OracleRaceSlugRoute;
  RacesSlugRoute: typeof RacesSlugRoute;
  OracleIndexRoute: typeof OracleIndexRoute;
  RacesIndexRoute: typeof RacesIndexRoute;
  UHandleIndexRoute: typeof UHandleIndexRoute;
  UHandleVsRivalRoute: typeof UHandleVsRivalRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/wall": {
      id: "/wall";
      path: "/wall";
      fullPath: "/wall";
      preLoaderRoute: typeof WallRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/terms": {
      id: "/terms";
      path: "/terms";
      fullPath: "/terms";
      preLoaderRoute: typeof TermsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/privacy": {
      id: "/privacy";
      path: "/privacy";
      fullPath: "/privacy";
      preLoaderRoute: typeof PrivacyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/me": {
      id: "/me";
      path: "/me";
      fullPath: "/me";
      preLoaderRoute: typeof MeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/leaderboards": {
      id: "/leaderboards";
      path: "/leaderboards";
      fullPath: "/leaderboards";
      preLoaderRoute: typeof LeaderboardsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/races/": {
      id: "/races/";
      path: "/races";
      fullPath: "/races/";
      preLoaderRoute: typeof RacesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/oracle/": {
      id: "/oracle/";
      path: "/oracle";
      fullPath: "/oracle/";
      preLoaderRoute: typeof OracleIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/races/$slug": {
      id: "/races/$slug";
      path: "/races/$slug";
      fullPath: "/races/$slug";
      preLoaderRoute: typeof RacesSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/oracle/$raceSlug": {
      id: "/oracle/$raceSlug";
      path: "/oracle/$raceSlug";
      fullPath: "/oracle/$raceSlug";
      preLoaderRoute: typeof OracleRaceSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/boom/$id": {
      id: "/boom/$id";
      path: "/boom/$id";
      fullPath: "/boom/$id";
      preLoaderRoute: typeof BoomIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/strava": {
      id: "/auth/strava";
      path: "/auth/strava";
      fullPath: "/auth/strava";
      preLoaderRoute: typeof AuthStravaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/u/$handle/": {
      id: "/u/$handle/";
      path: "/u/$handle";
      fullPath: "/u/$handle/";
      preLoaderRoute: typeof UHandleIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/u/$handle/vs/$rival": {
      id: "/u/$handle/vs/$rival";
      path: "/u/$handle/vs/$rival";
      fullPath: "/u/$handle/vs/$rival";
      preLoaderRoute: typeof UHandleVsRivalRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LeaderboardsRoute: LeaderboardsRoute,
  MeRoute: MeRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  WallRoute: WallRoute,
  AuthStravaRoute: AuthStravaRoute,
  BoomIdRoute: BoomIdRoute,
  OracleRaceSlugRoute: OracleRaceSlugRoute,
  RacesSlugRoute: RacesSlugRoute,
  OracleIndexRoute: OracleIndexRoute,
  RacesIndexRoute: RacesIndexRoute,
  UHandleIndexRoute: UHandleIndexRoute,
  UHandleVsRivalRoute: UHandleVsRivalRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
